import canvasSlice from './slice';
import * as Thunks from './thunks';

export const actions = { ...canvasSlice.actions, ...Thunks };
export default canvasSlice.reducer;
